var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleLoading = function SvgCircleLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.12C8 .503 7.496-.007 6.883.079a8 8 0 1 0 9.113 8.173c.02-.619-.542-1.064-1.158-.997-.615.067-1.048.624-1.101 1.24a5.76 5.76 0 1 1-6.85-6.143C7.493 2.23 8 1.74 8 1.12Z",
    fill: "url(#circle-loading_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-loading_svg__a",
    x1: 24.149,
    y1: 48.909,
    x2: -2.459,
    y2: 48.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#F953C6"
  })))));
};
export default SvgCircleLoading;